<template>
  <div class="card" style="margin-bottom: 20px;" v-if="showForm">
    <header class="card-header">
      <span class="card-header--title">Complete Your Consultation</span>
    </header>
    <div class="card-body">
      <highest-bmi-question
        :consultation-id="consultationId"
        :feet="feet"
        :inches="inches"
        :is-dashboard="true"
        form-prefix="dashboard"
      />
    </div>
  </div>
</template>

<script>
import HighestBmiQuestion from './HighestBmiQuestion.vue';

export default {
  name: 'HighestDashboardBmiQuestion',
  components: {
    HighestBmiQuestion
  },
  props: {
    consultationId: {
      type: [String, Number],
      required: true
    },
    feet: {
      type: Number,
      default: 0
    },
    inches: {
      type: Number,
      default: 0
    },
    showForm: {
      type: Boolean,
      default: true
    },
    csrfToken: {
      type: String,
      required: true
    },
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/HighestDashboardBmiQuestion.vue